export const buildingIcon = (
  <g fill="#686B91" fillRule="nonzero">
    <path d="M23.845 0H6.155a2 2 0 00-2 2v26a2 2 0 002 2h17.69a2 2 0 002-2V2a2 2 0 00-2-2zM6.155 2h17.69v26H6.155V2z" />
    <path d="M10.758 14H9.265a.746.746 0 00-.746.746v1.493c0 .412.334.746.746.746h1.493a.746.746 0 00.746-.746v-1.493a.746.746 0 00-.746-.746zM15.746 14h-1.492a.746.746 0 00-.747.746v1.493c0 .412.335.746.747.746h1.492a.746.746 0 00.747-.746v-1.493a.746.746 0 00-.747-.746zM20.735 14h-1.493a.746.746 0 00-.746.746v1.493c0 .412.334.746.746.746h1.493a.746.746 0 00.746-.746v-1.493a.746.746 0 00-.746-.746z" />
    <g>
      <path d="M10.758 9.012H9.265a.746.746 0 00-.746.746v1.493c0 .412.334.746.746.746h1.493a.746.746 0 00.746-.746V9.758a.746.746 0 00-.746-.746zM15.746 9.012h-1.492a.746.746 0 00-.747.746v1.493c0 .412.335.746.747.746h1.492a.746.746 0 00.747-.746V9.758a.746.746 0 00-.747-.746zM20.735 9.012h-1.493a.746.746 0 00-.746.746v1.493c0 .412.334.746.746.746h1.493a.746.746 0 00.746-.746V9.758a.746.746 0 00-.746-.746z" />
    </g>
    <g>
      <path d="M10.758 4.023H9.265a.746.746 0 00-.746.746v1.493c0 .412.334.746.746.746h1.493a.746.746 0 00.746-.746V4.769a.746.746 0 00-.746-.746zM15.746 4.023h-1.492a.746.746 0 00-.747.746v1.493c0 .412.335.746.747.746h1.492a.746.746 0 00.747-.746V4.769a.746.746 0 00-.747-.746zM20.735 4.023h-1.493a.746.746 0 00-.746.746v1.493c0 .412.334.746.746.746h1.493a.746.746 0 00.746-.746V4.769a.746.746 0 00-.746-.746z" />
    </g>
    <path d="M17.96 19.034a2 2 0 011.994 1.85l.006.15V29h-2v-7.966H13V29h-2v-7.966a2 2 0 011.85-1.995l.15-.005h4.96z" />
  </g>
);

export const copyIcon = (
  <g fill="#666666" fillRule="nonzero">
    <path
      d="M1583 5101c-72-24-127-65-163-119-57-86-60-112-60-483v-338l-437-3-438-3-56-26c-71-33-125-87-158-158l-26-56V245l26-56c33-71 87-125 158-158l56-26h3030l56 26c71 33 125 87 158 158l26 56 3 357 3 357 437 3 437 3 56 26c71 33 125 87 158 158l26 56v3670l-26 56c-33 71-87 125-158 158l-56 26-1500 2c-1423 2-1503 2-1552-16zm2977-2061V1280h-800v1228l114 4c124 3 145 11 190 72 29 39 29 133 0 172-45 61-66 69-190 72l-114 4v316l114 4c124 3 145 11 190 72 29 39 29 133 0 172-45 61-66 69-189 72l-114 4-3 221c-3 215-4 224-29 278-33 70-87 125-155 156-29 13-70 41-91 63-65 64-154 66-222 4l-38-34h-346l-38 34c-41 38-90 52-145 42-19-4-52-23-73-42l-38-34h-903v640h2880V3040zm-1120-960V320H560v3520h2880V2080z"
      transform="matrix(.1 0 0 -.1 0 512)"
    />
    <path
      d="M1615 3046c-37-17-70-52-84-89-6-16-11-102-11-197v-169l-199-3c-219-3-226-5-275-72-29-39-29-133 0-172 49-67 56-69 275-72l199-3v-318l-199-3c-219-3-226-5-275-72-29-39-29-133 0-172 49-67 56-69 274-72l199-3 3-194c3-212 5-220 72-269 39-29 133-29 172 0 67 49 69 57 72 270l3 194h318l3-194c3-213 5-221 72-270 39-29 133-29 172 0 67 49 69 57 72 269l3 194 179 3c162 3 181 5 206 24 53 39 69 71 69 134s-16 95-69 134c-25 19-44 21-207 24l-179 3v318l179 3c196 3 206 6 255 72 29 39 29 133 0 172-49 66-59 69-254 72l-179 3-3 184c-3 201-6 210-72 259-39 29-133 29-172 0-66-49-69-58-72-260l-3-184h-318l-3 184c-3 201-6 211-70 259-34 25-113 32-153 13zm545-936v-160h-320v320h320v-160z"
      transform="matrix(.1 0 0 -.1 0 512)"
    />
  </g>
);

export const eventsIcon = (
  <svg viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.7824 4.92881C26.7294 4.92657 26.6764 4.9262 26.6234 4.92775H24.6236V3.13857C24.6237 2.4229 23.9675 2 23.2801 2H21.4367C20.7493 2 20.2494 2.4229 20.2494 3.13857V4.92769H12.7506V3.13857C12.7506 2.4229 12.2507 2 11.5633 2H9.71976C9.03242 2 8.37624 2.4229 8.37624 3.13857V4.92769H6.3766C5.10012 4.89064 4.03649 5.938 4.00091 7.26692C3.99941 7.32208 3.99977 7.37737 4.00192 7.43254V26.2349C4.00192 27.6663 5.00174 29 6.37654 29H26.6234C27.9982 29 28.998 27.6663 28.998 26.2349V7.43254C29.0503 6.10418 28.0583 4.98323 26.7824 4.92881ZM21.4367 3.30121H23.3739V6.8795H21.4367V3.30121ZM9.71982 3.30121H11.5008V6.8795H9.71982V3.30121ZM27.7482 26.2349C27.7482 26.9506 27.3108 27.6988 26.6234 27.6988H6.3766C5.6892 27.6988 5.25179 26.9506 5.25179 26.2349V12.4097H27.7482V26.2349ZM27.7482 7.43254V11.1085H5.25173V7.43254C5.1988 6.82421 5.62958 6.28637 6.21387 6.23127C6.26794 6.22616 6.32236 6.22541 6.37654 6.22896H8.37624V6.94463C8.37624 7.6603 9.03236 8.18078 9.71976 8.18078H11.5633C12.2015 8.19902 12.733 7.67506 12.7506 7.01057C12.7512 6.98859 12.7512 6.96661 12.7506 6.94463V6.2289H20.2494V6.94457C20.2319 7.60906 20.7351 8.16247 21.3734 8.18071C21.3945 8.18134 21.4156 8.18134 21.4367 8.18071H23.2802C23.9676 8.18071 24.6237 7.66024 24.6237 6.94457V6.2289H26.6234C27.209 6.19048 27.7135 6.65354 27.7504 7.26318C27.7538 7.31959 27.7531 7.37625 27.7482 7.43254Z"
      fill="#F2C57C"
    />
    <path
      d="M12.6306 21.0644L12.0301 24.2568C12.0063 24.3937 12.0298 24.5344 12.0971 24.6574C12.2679 24.9698 12.671 25.0906 12.9975 24.9271L16 23.4267L19.0025 24.9271L19.3027 24.991C19.4475 24.9934 19.5888 24.9483 19.703 24.8633C19.9024 24.7239 20.005 24.4906 19.9699 24.2567L19.3694 21.0643L21.8048 18.8296C21.979 18.6494 22.0423 18.3952 21.9716 18.1593C21.8817 17.9411 21.6793 17.7838 21.4378 17.7442L18.1017 17.2654L16.6005 14.3603C16.535 14.231 16.426 14.1266 16.2909 14.064C15.9592 13.9103 15.5602 14.043 15.3995 14.3603L13.8983 17.2654L10.5622 17.7442C10.3207 17.7837 10.1183 17.9411 10.0284 18.1593C9.95772 18.3952 10.021 18.6494 10.1952 18.8296L12.6306 21.0644ZM14.4654 18.4785C14.6749 18.4485 14.8525 18.3151 14.9325 18.1274L16 16.0842L17.0675 18.1274C17.1476 18.3151 17.325 18.4485 17.5346 18.4785L19.9032 18.7977L18.2018 20.362C18.0433 20.5122 17.969 20.7255 18.0016 20.9366L18.4019 23.2033L16.3002 22.1179L15.9999 22.054L15.6997 22.1179L13.598 23.2033L13.9983 20.9366C14.031 20.7255 13.9566 20.5122 13.7981 20.362L12.0967 18.7977L14.4654 18.4785Z"
      fill="#F2C57C"
    />
  </svg>
);

export const searchIcon = (
  <g stroke="#4536A7" fill="none" fillRule="evenodd">
    <circle strokeWidth="2" cx="20.115" cy="11.885" r="7.922" />
    <rect
      strokeWidth="1.5"
      transform="rotate(-45 7.86 24.216)"
      x="3.263"
      y="22.466"
      width="9.195"
      height="3.5"
      rx="1"
    />
    <path
      strokeWidth="2"
      strokeLinecap="square"
      d="M14.074 17.926l-2.88 2.88"
    />
  </g>
);

export const staffIcon = (
  <path
    d="M19.581 15.634A7.483 7.483 0 0023.2 9.22c0-4.119-3.325-7.47-7.413-7.47s-7.414 3.351-7.414 7.47a7.483 7.483 0 003.618 6.412c-4.864 1.564-8.56 6.158-8.56 11.765a2.474 2.474 0 002.47 2.471h19.77a2.474 2.474 0 002.472-2.471c0-5.607-3.696-10.2-8.56-11.764zM10.02 9.22c0-3.21 2.587-5.822 5.767-5.822s5.766 2.612 5.766 5.822-2.587 5.82-5.766 5.82c-3.18 0-5.767-2.61-5.767-5.82zm7.307 7.58l-1.54 1.286-1.54-1.287a10.756 10.756 0 013.08 0zM13.44 28.22H5.9a.825.825 0 01-.823-.823c0-3.415 1.606-6.461 4.103-8.423l2.625 3.937c.288.432.9.494 1.268.126l.29-.29.742 1.484-.665 3.99zm-.421-7.459l-.002.002-.398.398-2.069-3.103a10.66 10.66 0 011.73-.78c.08.103-.068-.03 2.286 1.936l-1.547 1.547zm2.092 7.46l.663-3.984a.822.822 0 00.012-.135c0 .045.003.09.01.135l.665 3.984h-1.35zm.762-4.488a.823.823 0 00-.087.368.824.824 0 00-.087-.368L14.59 21.52l1.195-1.195 1.194 1.195-1.107 2.214zm3.419-6.455c.686.239 1.341.546 1.957.912l-2.258 3.01-.436-.437-.002-.002-1.548-1.547c2.358-1.97 2.208-1.834 2.287-1.936zm6.379 10.943h-7.54l-.665-3.99.742-1.484.29.29a.824.824 0 001.242-.088l2.857-3.81a10.692 10.692 0 013.897 8.258c0 .454-.37.824-.823.824z"
    fill="#1D7095"
    fillRule="nonzero"
  />
);

export const deliveryIcon = (
  <g fill="#686B91" fillRule="nonzero">
    <path d="M8.739 4.316a.75.75 0 01.92-.357L9.75 4l13.86 7.268v8.983a.75.75 0 01-1.492.102l-.007-.102-.001-8.077L9.055 5.328a.75.75 0 01-.357-.919l.04-.093z" />
    <path d="M15.273.348L1.94 7.325a1 1 0 00-.536.886V23.54a1 1 0 00.533.885l13.332 7.034a1 1 0 00.93 0l13.409-7.033a1 1 0 00.535-.886V8.211a1 1 0 00-.538-.887L16.198.347a1 1 0 00-.925 0zm.464 2.013l12.407 6.457v14.116l-12.407 6.509-12.333-6.507V8.816l12.333-6.455z" />
    <path d="M28.68 7.325l.928 1.772-13.873 7.264L1.939 9.096l.932-1.77 12.866 6.776z" />
    <path d="M16.844 15.232v15.341h-2V15.232z" />
  </g>
);

export const adminDeliveryIcon = (
  <g fill="#FEC007" fillRule="nonzero">
    <path d="M8.739 4.316a.75.75 0 01.92-.357L9.75 4l13.86 7.268v8.983a.75.75 0 01-1.492.102l-.007-.102-.001-8.077L9.055 5.328a.75.75 0 01-.357-.919l.04-.093z" />
    <path d="M15.273.348L1.94 7.325a1 1 0 00-.536.886V23.54a1 1 0 00.533.885l13.332 7.034a1 1 0 00.93 0l13.409-7.033a1 1 0 00.535-.886V8.211a1 1 0 00-.538-.887L16.198.347a1 1 0 00-.925 0zm.464 2.013l12.407 6.457v14.116l-12.407 6.509-12.333-6.507V8.816l12.333-6.455z" />
    <path d="M28.68 7.325l.928 1.772-13.873 7.264L1.939 9.096l.932-1.77 12.866 6.776z" />
    <path d="M16.844 15.232v15.341h-2V15.232z" />
  </g>
);

export const srIcon = (
  <g fill="#686B91" fillRule="nonzero">
    <path d="M21.64-.106h4.824V7.26h-4.41l-.408-.22c-2.315-1.205-3.378-.824-3.827 1.253l-.022.113v6.716h-5.29V8.966l-.104-.26c-1.418-3.41-3.701-3.596-7.558-.487l-2.213 1.783.782-2.731C4.8 2.433 9.242-.006 16.491-.093l.713-.002.243.188C19.138 1.4 20.32 1.398 21.37.2l.27-.306zm3.025 1.8h-2.231l-.032.031c-1.577 1.525-3.537 1.535-5.623.108l-.177-.127-.108.001c-4.507.055-7.666 1.045-9.56 2.954l-.222.234.013-.006c3.42-1.563 6.055-.376 7.526 3.6l.055.15v4.682h1.69V8.313l.016-.168.046-.226c.712-3.258 2.988-4.153 6.21-2.58l.24.121h2.157V1.694z" />
    <path d="M13.206 13.418l1.42 1.105c-.85 1.095-1.256 2.626-1.19 4.62l.03.564.226 3.58c.188 3.208.188 4.758-.075 5.709l-.029.1c-.179.578-.19.843-.132.916.128.165.666.31 1.748.293l.224-.006.06 1.8c-1.757.058-2.86-.221-3.452-.98-.503-.645-.51-1.35-.232-2.34l.064-.215c.21-.678.199-2.311.003-5.575l-.214-3.382c-.147-2.445.303-4.44 1.374-5.954l.175-.235z" />
    <path d="M16.83 13.418l-1.421 1.105c.851 1.095 1.256 2.626 1.19 4.62l-.03.564-.226 3.58c-.188 3.208-.187 4.758.075 5.709l.03.1c.178.578.189.843.132.916-.129.165-.667.31-1.749.293l-.223-.006-.06 1.8c1.756.058 2.86-.221 3.451-.98.503-.645.511-1.35.232-2.34l-.064-.215c-.21-.678-.198-2.311-.003-5.575l.215-3.382c.146-2.445-.303-4.44-1.375-5.954l-.174-.235z" />
  </g>
);

export const visitorIcon = (
  <g fill="none" fillRule="evenodd">
    <g fill="#A246AD" fillRule="nonzero">
      <path d="M19.599 4.597h8.33a3 3 0 013 3v16.485a3 3 0 01-3 3H3.912a3 3 0 01-3-3V7.597a3 3 0 013-3h8.814v3H19.6v-3zm-7.338 2h-8.35a1 1 0 00-.992.884l-.007.116v16.485a1 1 0 00.883.993l.117.007h24.017a1 1 0 00.993-.883l.007-.117V7.597a1 1 0 00-.883-.993l-.117-.007H19.8v1.497h-7.553l.015-1.497z" />
      <path d="M13.159 18.283a3 3 0 012.995 2.824l.005.176v1.822h-2v-1.822a1 1 0 00-.884-.993l-.116-.007H7.035a1 1 0 00-.993.883l-.007.117v1.822h-2v-1.822a3 3 0 012.824-2.995l.176-.005h6.124zM10.097 10.993a3.029 3.029 0 110 6.058 3.029 3.029 0 010-6.058zm0 2a1.029 1.029 0 100 2.058 1.029 1.029 0 000-2.058zM18.824 2.34c.945 0 1.712.766 1.712 1.712V6.95c0 .946-.767 1.713-1.712 1.713H12.76a1.712 1.712 0 01-1.712-1.713V4.052c0-.946.766-1.713 1.712-1.713h6.063zm-.289 1.999h-5.487v2.323h5.487V4.339zM26.444 16.52a1 1 0 01.116 1.993l-.116.007H19.2a1 1 0 01-.117-1.994l.117-.006h7.243zM26.444 20.541a1 1 0 01.116 1.994l-.116.006H19.2a1 1 0 01-.117-1.993l.117-.007h7.243zM26.444 12.498a1 1 0 01.116 1.993l-.116.007H19.2a1 1 0 01-.117-1.993l.117-.007h7.243z" />
    </g>
  </g>
);

export const remoteDoormanIcon = (
  <g clipPath="url(#clip0_3435_74947)">
    <path
      d="M16.9842 17.3229H5.42533C2.65199 17.3229 0.395996 19.5789 0.395996 22.3522V28.2513C0.395996 28.665 0.730531 29 1.14422 29H21.2653C21.6785 29 22.0135 28.665 22.0135 28.2518V22.3522C22.0135 19.5789 19.7575 17.3229 16.9842 17.3229ZM13.2077 18.8189L11.2048 20.8218L9.2018 18.8193L13.2077 18.8189ZM1.89198 27.5036V22.3522C1.89198 20.4039 3.47701 18.8189 5.42533 18.8189H7.08575L10.2888 22.0219L7.45091 27.5036H1.89198ZM9.13583 27.5036L11.2048 23.5071L13.2737 27.5036H9.13583ZM14.9586 27.5036L12.1207 22.0219L15.3238 18.8189H16.9842C18.9325 18.8189 20.5171 20.4039 20.5171 22.3522V27.5036H14.9586Z"
      fill="#FEC007"
    />
    <path
      d="M17.3066 22.4135H15.4694C15.2743 22.4183 15.0888 22.4993 14.9525 22.639C14.8163 22.7788 14.74 22.9663 14.74 23.1614C14.74 23.3566 14.8163 23.5441 14.9525 23.6838C15.0888 23.8236 15.2743 23.9045 15.4694 23.9094H17.307C17.5022 23.9045 17.6876 23.8236 17.8239 23.6838C17.9602 23.5441 18.0365 23.3566 18.0365 23.1614C18.0365 22.9663 17.9602 22.7788 17.8239 22.639C17.6876 22.4993 17.5017 22.4183 17.3066 22.4135Z"
      fill="#FEC007"
    />
    <path
      d="M16.3878 3.66394H6.02144C5.60822 3.66394 5.27368 3.99848 5.27368 4.41217V10.1059C5.27368 13.3768 7.93441 16.038 11.2053 16.038C14.4757 16.038 17.1369 13.3768 17.1369 10.1059V4.41217C17.1367 4.21364 17.0577 4.02333 16.9172 3.88303C16.7767 3.74274 16.5863 3.66394 16.3878 3.66394ZM6.76967 5.15992H15.6405V7.16478H6.76919L6.76967 5.15992ZM15.6405 10.1059C15.6405 12.5513 13.6507 14.5415 11.2053 14.5415C8.75944 14.5415 6.76967 12.5517 6.76967 10.1059V8.66076H15.6405V10.1059Z"
      fill="#FEC007"
    />
  </g>
);

export const cardIcon = (
  <g fill="#FEC007" fillRule="nonzero">
    <path d="M28.43 6.159a3 3 0 013 3v14.486a3 3 0 01-3 3H3.67a3 3 0 01-3-3V9.159a3 3 0 013-3h24.76zm0 2H3.67a1 1 0 00-.993.883l-.006.117v14.486a1 1 0 00.883.993l.117.007H28.43a1 1 0 00.993-.884l.007-.116V9.159a1 1 0 00-.884-.994l-.116-.006z" />
    <path d="M12.685 18.577a1 1 0 01.117 1.994l-.117.006H5.27a1 1 0 01-.116-1.993l.116-.007h7.416zM26.049 17.76a1.5 1.5 0 011.5 1.5v2.209a1.5 1.5 0 01-1.5 1.5H23.84a1.5 1.5 0 01-1.5-1.5V19.26a1.5 1.5 0 011.5-1.5h2.209zm0 1.5H23.84v2.209h2.209V19.26zM12.685 21.13a1 1 0 01.117 1.993l-.117.006H5.27a1 1 0 01-.116-1.993l.116-.007h7.416zM31.342 11.328v3H.67v-3z" />
  </g>
);

export const monetizationIcon = (
  <g fill="#FEC007" fillRule="nonzero">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z" />{' '}
  </g>
);

export const docIcon = (
  <g fill="#4536A7" fillRule="nonzero">
    <path d="M27.625 13.103v-7.13c0-.722-.281-1.4-.791-1.91l-2.545-2.545a2.682 2.682 0 00-1.909-.79H6.93a2.702 2.702 0 00-2.7 2.7v25.314c0 1.488 1.211 2.7 2.7 2.7h17.996c1.489 0 2.7-1.212 2.7-2.7v-8-7.64zm-5.4-10.576c.17 0 .498-.03.791.264l2.545 2.545c.286.285.264.598.264.79h-3.6V2.528zm3.6 26.215a.9.9 0 01-.9.9H6.93a.9.9 0 01-.9-.9V3.427a.9.9 0 01.9-.9h13.497v4.5a.9.9 0 00.9.9h4.499v6.977s-.015 6.618.084 6.52v2.209l-.084 5.109z" />
    <path d="M21.326 9.726H8.729a.9.9 0 000 1.8h12.597a.9.9 0 000-1.8zM17.727 13.325H8.729a.9.9 0 000 1.8h8.998a.9.9 0 000-1.8zM17.727 16.924H8.729a.9.9 0 000 1.8h8.998a.9.9 0 000-1.8zM17.727 20.523H8.729a.9.9 0 000 1.8h8.998a.9.9 0 000-1.8zM21.326 26.042h-5.399a.9.9 0 000 1.8h5.399a.9.9 0 000-1.8z" />
  </g>
);

export const amenityIcon = (
  <g fill="#CF5856" fillRule="nonzero">
    <path d="M25.318 5.118h-2.619v-1.4a.873.873 0 10-1.745 0v1.4H10.482v-1.4a.873.873 0 10-1.746 0v1.4H6.118A2.618 2.618 0 003.5 7.736v17.488a2.618 2.618 0 002.618 2.618h19.2a2.618 2.618 0 002.618-2.618V7.736a2.618 2.618 0 00-2.618-2.618zm.872 20.106c0 .482-.39.873-.873.873H6.118a.873.873 0 01-.873-.873V12.972H26.19v12.252zM5.245 11.227v-3.49c0-.483.391-.874.873-.874h2.618V8.07a.873.873 0 101.746 0V6.863h10.472V8.07a.873.873 0 101.745 0V6.863h2.619c.482 0 .872.391.872.873v3.491H5.245z" />
    <path d="M21.55 15.192a.873.873 0 00-1.213 0l-6.365 6.365-2.873-2.874a.873.873 0 00-1.234 1.234l3.49 3.49c.341.341.894.341 1.234 0l6.982-6.98a.873.873 0 00-.021-1.235z" />
  </g>
);

export const exportIcon = (
  <g stroke="#979797" fill="none" fillRule="evenodd">
    <path
      strokeWidth="1.6"
      strokeLinecap="round"
      d="M18.375 19.794h11.457M27.397 16.937l2.435 2.857-2.435 2.79"
    />
    <path
      d="M8.432 4.337h8.909v5.621a1 1 0 001 1h5.436v15.71a1 1 0 01-1 1H8.432a1 1 0 01-1-1V5.337a1 1 0 011-1z"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      strokeWidth="1.5"
      strokeLinecap="round"
      d="M17.418 4.337l6.314 6.519"
    />
  </g>
);

export const exportViewIcon = (
  <g stroke="#FFF" fill="none" fillRule="evenodd">
    <path
      strokeWidth="1.6"
      strokeLinecap="round"
      d="M18.375 19.794h11.457M27.397 16.937l2.435 2.857-2.435 2.79"
    />
    <path
      d="M8.432 4.337h8.909v5.621a1 1 0 001 1h5.436v15.71a1 1 0 01-1 1H8.432a1 1 0 01-1-1V5.337a1 1 0 011-1z"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      strokeWidth="1.5"
      strokeLinecap="round"
      d="M17.418 4.337l6.314 6.519"
    />
  </g>
);

export const adminIcon = (
  <g stroke="#FEC007" strokeWidth="1.5" fill="none" fillRule="evenodd">
    <path d="M3.878 11.276l3.871 13.928h16.499l3.874-13.928-6.08 3.026-6.015-6.766-5.918 6.766zM6.875 21.169h18.269" />
  </g>
);

export const pmcIcon = (
  <g stroke="#FEC007" fill="none" fillRule="evenodd">
    <path strokeWidth="1.5" d="M16.009 10.4v11.3" />
    <path
      d="M12.8 4h6.4a1 1 0 011 1v4.4a1 1 0 01-1 1h-6.4a1 1 0 01-1-1V5a1 1 0 011-1zM13.2 21.7h5.481a1 1 0 011 1v3.7a1 1 0 01-1 1H13.2a1 1 0 01-1-1v-3.7a1 1 0 011-1zM24.2 21.7h5.481a1 1 0 011 1v3.7a1 1 0 01-1 1H24.2a1 1 0 01-1-1v-3.7a1 1 0 011-1zM2.2 21.7h5.481a1 1 0 011 1v3.7a1 1 0 01-1 1H2.2a1 1 0 01-1-1v-3.7a1 1 0 011-1z"
      strokeWidth="1.7"
    />
    <path strokeWidth="1.5" d="M4.94 21.7V16h22v5.7" />
  </g>
);

export const ipIcon = (
  <g fill="#FEC007" fillRule="nonzero">
    <path d="M23.65 6.2A10.854 10.854 0 0015.925 3 10.854 10.854 0 008.2 6.2 10.854 10.854 0 005 13.925c0 2.552.899 5.035 2.531 6.993.416.498.878.961 1.375 1.378l6.48 6.48a.76.76 0 001.078 0l6.48-6.48a10.937 10.937 0 003.906-8.371c0-2.918-1.136-5.662-3.2-7.725zm-1.76 14.994l-5.965 5.965-5.965-5.965a.805.805 0 00-.05-.047 9.41 9.41 0 01-3.384-7.222c0-5.183 4.216-9.4 9.4-9.4 5.182 0 9.399 4.217 9.399 9.4a9.41 9.41 0 01-3.384 7.222.805.805 0 00-.05.047z" />
    <path d="M18.313 11.423h-2.709a.763.763 0 00-.763.763v4.722a.763.763 0 001.526 0v-1.599h1.946a1.945 1.945 0 001.943-1.943 1.945 1.945 0 00-1.943-1.943zm0 2.361h-1.946v-.835h1.946a.418.418 0 010 .835zM13.348 11.423a.763.763 0 00-.763.763v4.722a.763.763 0 001.525 0v-4.722a.763.763 0 00-.762-.763z" />
  </g>
);

export const activityIcon = (
  <path
    d="M2.737 17.641h3.53l2.82-4.911 5.8 12.623L19.56 7l3.238 12.45 2.209-1.808h4.219"
    stroke="#FEC007"
    strokeWidth="1.5"
    fill="none"
    fillRule="evenodd"
    strokeLinecap="round"
  />
);

export const externalAccountIcon = (
  <path
    d="M29 3.867v7.8a.866.866 0 11-1.733 0V5.959L14.879 18.346a.864.864 0 01-1.225 0 .866.866 0 010-1.225L26.04 4.733h-5.708a.866.866 0 110-1.733h7.8c.48 0 .867.388.867.867zM25.533 26.4V16a.866.866 0 10-1.733 0v10.4a.867.867 0 01-.867.867H5.6a.867.867 0 01-.867-.867V9.067c0-.479.389-.867.867-.867H16a.866.866 0 100-1.733H5.6a2.603 2.603 0 00-2.6 2.6V26.4C3 27.834 4.166 29 5.6 29h17.333c1.434 0 2.6-1.166 2.6-2.6z"
    fill="#FEC007"
    fillRule="nonzero"
  />
);

export const folderIcon = (
  <path
    d="M29 28.531H3a3 3 0 01-3-3v-20a3 3 0 013-3h8.6c.516 0 1.013.2 1.384.558L16.4 6.364c.05.051.096.107.135.167H29a3 3 0 013 3v16a3 3 0 01-3 3zm-27-20v17a1 1 0 001 1h26a1 1 0 001-1v-16a1 1 0 00-1-1H2z"
    fill="#FFD67F"
    fillRule="nonzero"
  />
);

export const pdfIcon = (
  <g fill="none" fillRule="evenodd">
    <path
      d="M9.24 13.363h2.274c1.125 0 1.894.77 1.894 1.907 0 1.117-.797 1.882-1.937 1.882h-1.223V19H9.24v-5.637zm1.008.844v2.11h.996c.719 0 1.14-.376 1.14-1.047 0-.692-.41-1.063-1.136-1.063h-1zm3.892-.844h2.113c1.676 0 2.652 1.024 2.652 2.793 0 1.809-.965 2.844-2.652 2.844H14.14v-5.637zm1.007.871v3.895h.973c1.121 0 1.758-.7 1.758-1.957 0-1.23-.652-1.938-1.758-1.938h-.973zM20.684 19h-1.008v-5.637h3.594v.871h-2.586v1.641h2.363v.84h-2.363V19z"
      fill="#D41E46"
    />
    <path
      d="M28.375 12.894v-7.43c0-.751-.293-1.457-.824-1.989L24.9.824A2.794 2.794 0 0022.91 0H6.813A2.816 2.816 0 004 2.813v26.375A2.816 2.816 0 006.813 32h18.75a2.816 2.816 0 002.812-2.813v-8.335-7.958zM22.75 1.875c.177 0 .518-.03.824.275L26.225 4.8c.298.298.275.624.275.824h-3.75v-3.75zm3.75 27.313c0 .516-.42.937-.938.937H6.813a.939.939 0 01-.937-.938V2.813c0-.516.42-.937.938-.937h14.062v4.688c0 .517.42.937.938.937H26.5v7.27s-.016 6.895.087 6.793v2.302l-.087 5.323z"
      fill="#B0B0B0"
      fillRule="nonzero"
    />
  </g>
);

export const imgIcon = (
  <g fill="none" fillRule="evenodd">
    <path
      d="M10.248 19H9.24v-5.637h1.008V19zm6.833 0h-.937v-3.965h-.055l-1.559 3.746h-.718l-1.559-3.746h-.055V19h-.937v-5.637h1.18l1.695 4.106h.07l1.695-4.106h1.18V19zm5.888-2.258c0 1.465-.961 2.399-2.465 2.399-1.633 0-2.648-1.133-2.648-2.961 0-1.805 1.027-2.957 2.632-2.957 1.301 0 2.254.742 2.434 1.894h-1.004c-.203-.64-.707-.996-1.43-.996-.984 0-1.601.785-1.601 2.05 0 1.282.629 2.071 1.633 2.071.859 0 1.445-.523 1.46-1.3l.004-.118H20.63v-.789h2.34v.707z"
      fill="#9B59B6"
    />
    <path
      d="M28.375 12.894v-7.43c0-.751-.293-1.457-.824-1.989L24.9.824A2.794 2.794 0 0022.91 0H6.813A2.816 2.816 0 004 2.813v26.375A2.816 2.816 0 006.813 32h18.75a2.816 2.816 0 002.812-2.813v-8.335-7.958zM22.75 1.875c.177 0 .518-.03.824.275L26.225 4.8c.298.298.275.624.275.824h-3.75v-3.75zm3.75 27.313c0 .516-.42.937-.938.937H6.813a.939.939 0 01-.937-.938V2.813c0-.516.42-.937.938-.937h14.062v4.688c0 .517.42.937.938.937H26.5v7.27s-.016 6.895.087 6.793v2.302l-.087 5.323z"
      fill="#B0B0B0"
      fillRule="nonzero"
    />
  </g>
);

export const imgDocumentIcon = (
  <g fill="none" fillRule="evenodd">
    <path
      d="M10.248 19H9.24v-5.637h1.008V19zm6.833 0h-.937v-3.965h-.055l-1.559 3.746h-.718l-1.559-3.746h-.055V19h-.937v-5.637h1.18l1.695 4.106h.07l1.695-4.106h1.18V19zm5.888-2.258c0 1.465-.961 2.399-2.465 2.399-1.633 0-2.648-1.133-2.648-2.961 0-1.805 1.027-2.957 2.632-2.957 1.301 0 2.254.742 2.434 1.894h-1.004c-.203-.64-.707-.996-1.43-.996-.984 0-1.601.785-1.601 2.05 0 1.282.629 2.071 1.633 2.071.859 0 1.445-.523 1.46-1.3l.004-.118H20.63v-.789h2.34v.707z"
      fill="#9B59B6"
    />
    <path
      d="M28.375 12.894v-7.43c0-.751-.293-1.457-.824-1.989L24.9.824A2.794 2.794 0 0022.91 0H6.813A2.816 2.816 0 004 2.813v26.375A2.816 2.816 0 006.813 32h18.75a2.816 2.816 0 002.812-2.813v-8.335-7.958zM22.75 1.875c.177 0 .518-.03.824.275L26.225 4.8c.298.298.275.624.275.824h-3.75v-3.75zm3.75 27.313c0 .516-.42.937-.938.937H6.813a.939.939 0 01-.937-.938V2.813c0-.516.42-.937.938-.937h14.062v4.688c0 .517.42.937.938.937H26.5v7.27s-.016 6.895.087 6.793v2.302l-.087 5.323z"
      fill="#B0B0B0"
      fillRule="nonzero"
    />
  </g>
);

export const pdfDocumentIcon = (
  <g fill="none" fillRule="evenodd">
    <path
      d="M9.24 13.363h2.274c1.125 0 1.894.77 1.894 1.907 0 1.117-.797 1.882-1.937 1.882h-1.223V19H9.24v-5.637zm1.008.844v2.11h.996c.719 0 1.14-.376 1.14-1.047 0-.692-.41-1.063-1.136-1.063h-1zm3.892-.844h2.113c1.676 0 2.652 1.024 2.652 2.793 0 1.809-.965 2.844-2.652 2.844H14.14v-5.637zm1.007.871v3.895h.973c1.121 0 1.758-.7 1.758-1.957 0-1.23-.652-1.938-1.758-1.938h-.973zM20.684 19h-1.008v-5.637h3.594v.871h-2.586v1.641h2.363v.84h-2.363V19z"
      fill="#D41E46"
    />
    <path
      d="M28.375 12.894v-7.43c0-.751-.293-1.457-.824-1.989L24.9.824A2.794 2.794 0 0022.91 0H6.813A2.816 2.816 0 004 2.813v26.375A2.816 2.816 0 006.813 32h18.75a2.816 2.816 0 002.812-2.813v-8.335-7.958zM22.75 1.875c.177 0 .518-.03.824.275L26.225 4.8c.298.298.275.624.275.824h-3.75v-3.75zm3.75 27.313c0 .516-.42.937-.938.937H6.813a.939.939 0 01-.937-.938V2.813c0-.516.42-.937.938-.937h14.062v4.688c0 .517.42.937.938.937H26.5v7.27s-.016 6.895.087 6.793v2.302l-.087 5.323z"
      fill="#B0B0B0"
      fillRule="nonzero"
    />
  </g>
);

const commentIconPath = (
  <g transform="translate(2.611 4.5)">
    <path d="M22.234.027H3.544A3.548 3.548 0 000 3.57v11.438a3.548 3.548 0 003.531 3.544v5.19l7.46-5.19h11.243a3.548 3.548 0 003.544-3.544V3.57A3.548 3.548 0 0022.234.027zm2.033 14.982a2.036 2.036 0 01-2.033 2.033H10.517l-5.475 3.81v-3.81H3.544A2.036 2.036 0 011.51 15.01V3.57c0-1.122.913-2.034 2.034-2.034h18.69c1.121 0 2.033.912 2.033 2.034v11.438z" />
    <path d="M6.89930014 5.36386719L18.8784776 5.36386719 18.8784776 6.87428385 6.89930014 6.87428385z" />
    <path d="M6.89930014 8.58608941L18.8784776 8.58608941 18.8784776 10.0965061 6.89930014 10.0965061z" />
    <path d="M6.89930014 11.8083116L18.8784776 11.8083116 18.8784776 13.3187283 6.89930014 13.3187283z" />
  </g>
);

export const commentIcon = (
  <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
    <g fill="#666" fillRule="nonzero">
      {commentIconPath}
    </g>
  </g>
);

export const disabledCommentIcon = (
  <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
    <g fill="#00000042" fillRule="nonzero">
      {commentIconPath}
    </g>
  </g>
);

export const pinIcon = (
  <g>
    <path fill="none" d="M0 0H24V24H0z" />
    <path
      fillRule="evenodd"
      fill="#9e9e9e"
      d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"
    />
  </g>
);

export const residentsIcon = (
  <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
    <g fill="#A246AD" fillRule="nonzero">
      <g transform="translate(0 6.546)">
        <path d="M2.15 17.675h7.703c.42 0 .808-.136 1.124-.366.315.23.704.366 1.123.366h7.703c.42 0 .808-.136 1.124-.366.315.23.704.366 1.123.366h7.703a1.916 1.916 0 001.914-1.914V11.17a4.145 4.145 0 00-2.255-3.706 4.54 4.54 0 001.05-2.906 4.565 4.565 0 00-4.56-4.56 4.565 4.565 0 00-4.56 4.56c0 1.103.394 2.117 1.049 2.906-.584.3-1.084.731-1.464 1.255a4.133 4.133 0 00-1.465-1.255 4.538 4.538 0 001.05-2.906 4.565 4.565 0 00-4.56-4.56 4.565 4.565 0 00-4.56 4.56 4.54 4.54 0 001.049 2.906 4.133 4.133 0 00-1.464 1.256 4.137 4.137 0 00-1.465-1.256 4.538 4.538 0 001.05-2.906 4.565 4.565 0 00-4.56-4.56 4.565 4.565 0 00-4.56 4.56A4.54 4.54 0 002.49 7.463 4.146 4.146 0 00.236 11.17v4.591c0 1.056.859 1.914 1.914 1.914zM25.902 1.578a2.982 2.982 0 012.979 2.979 2.982 2.982 0 01-2.98 2.978 2.982 2.982 0 01-2.978-2.978 2.982 2.982 0 012.979-2.98zm-2.054 7.048a4.53 4.53 0 002.054.49c.738 0 1.436-.177 2.053-.49a2.569 2.569 0 012.131 2.543v4.592c0 .184-.15.333-.333.333H22.05a.333.333 0 01-.333-.333V11.17c0-1.27.903-2.329 2.131-2.543zm-7.896-7.048a2.982 2.982 0 012.979 2.979 2.982 2.982 0 01-2.98 2.978 2.982 2.982 0 01-2.978-2.978 2.982 2.982 0 012.979-2.98zm-2.054 7.048c.618.313 1.315.49 2.054.49a4.53 4.53 0 002.053-.49 2.569 2.569 0 012.131 2.543v4.592c0 .184-.149.333-.333.333H12.1a.333.333 0 01-.333-.333V11.17c0-1.27.903-2.329 2.131-2.543zM6.002 1.578A2.982 2.982 0 018.98 4.557 2.982 2.982 0 016 7.535a2.982 2.982 0 01-2.978-2.978 2.982 2.982 0 012.979-2.98zm-4.185 9.591c0-1.27.903-2.329 2.131-2.543a4.53 4.53 0 002.054.49 4.53 4.53 0 002.053-.49 2.569 2.569 0 012.131 2.543v4.592c0 .184-.149.333-.333.333H2.15a.333.333 0 01-.333-.333V11.17z" />
      </g>
    </g>
  </g>
);
